import { render } from "./UserSubscription.vue?vue&type=template&id=288d04fd"
import script from "./UserSubscription.vue?vue&type=script&lang=js"
export * from "./UserSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__